class Unauthorized extends Error {
  constructor(message) {
    super(message);
    this.name = "Unauthorized";
    console.log(`Unauthorized Error: ${message}`);
  }
}

export default Unauthorized